import type { Tab } from '../../../../types/Tab';

const GAME_PLATFORM_TAB_TYPE = 'label_text_game_platform';
const OTHER_TAB_VALUE = 'other';

// TODO: remove once we have support from api for colors for specific named tabs
export const SPECIFIC_TAB_COLORS: Record<string, string> = {
  ps4: 'var(--hawk-playstation-white)',
  ps5: 'var(--hawk-playstation-blue)',
  xbox: 'var(--hawk-xbox-green)',
  'xbox-360': 'var(--hawk-xbox-green)',
  'xbox-one': 'var(--hawk-xbox-green)',
  'xbox-series-x': 'var(--hawk-black)',
  pc: 'var(--hawk-pc-orange)',
  switch: 'var(--hawk-nintendo-red)',
  'switch-2': 'var(--hawk-nintendo-red)',
  'nintendo-switch-2': 'var(--hawk-nintendo-red)',
  [OTHER_TAB_VALUE]: 'var(--hawk-grey)',
};

const hasSpecificColor = (tab: Tab): boolean =>
  tab.value !== OTHER_TAB_VALUE && tab.value in SPECIFIC_TAB_COLORS;

export const getIsSpecificNamedTab = (tabs: Tab[], activeTab: Tab): boolean => {
  if (activeTab.type === GAME_PLATFORM_TAB_TYPE) {
    return activeTab.value === OTHER_TAB_VALUE || tabs.some(hasSpecificColor);
  }
  return hasSpecificColor(activeTab);
};

export const getIsOutlinedTab = (isSpecificNamedTab: boolean, tabColor?: string): boolean =>
  isSpecificNamedTab && tabColor === undefined;
